import { render, staticRenderFns } from "./CajaMensualCrud.vue?vue&type=template&id=fc8e5bba"
import script from "./CajaMensualCrud.vue?vue&type=script&lang=js"
export * from "./CajaMensualCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports